import {
  apiURL
} from '../../config/app';

const getExchangeList = async ({date, currency}) => {
  const response = await fetch(`${apiURL}/exchange?${currency ? `currency=${currency}&` : ''}${date ? `date=${date}` : ''}`, {
    method: 'GET',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
  })
  if (!response.ok)
    throw await response.json()
  
  return response.json();
};

const getQuote = async ({date}) => {
  const response = await fetch(`${apiURL}/qod?${date ? `date=${date}` : ''}`, {
    method: 'GET',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
  })
  if (!response.ok)
    throw await response.json()
  
  return response.json();
};

export default {
  getExchangeList,
  getQuote
};



// WEBPACK FOOTER //
// ./api/dashboard.js